/**
 * This is a collection of helpful typesafe type guards
 * See more on https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */

export const isObject = (v: unknown): v is object => {
  return !!v && typeof v === 'object';
};

export const isNumber = (v: unknown): v is number => {
  return typeof v === 'number';
};

export const isString = (v: unknown): v is string => {
  return typeof v === 'string';
};

export const isBoolean = (v: unknown): v is boolean => {
  return typeof v === 'boolean';
};

export const isNotBoolean = <T>(v: T): v is Exclude<T, boolean> => {
  return typeof v !== 'boolean';
};

export const isArray = (v: unknown): v is unknown[] => {
  return Array.isArray(v);
};

export const isFunction = (v: unknown): v is Function => {
  return typeof v === 'function';
};

export const isNotNullable = <T>(v: T): v is Exclude<T, undefined | null> => {
  return v !== undefined && v !== null;
};

// @deprecated, please use `isNotNullable` instead
export const nonNullish = <T>(v: T): v is NonNullable<T> => {
  return v !== undefined && v !== null;
};

export const isOneOf = <B, T1 extends B, T2 extends B>(isT1: (x: B) => x is T1, isT2: (x: B) => x is T2) => {
  return (x: B): x is T1 | T2 => isT1(x) || isT2(x);
};
